import { OptionSubCategory, tryLoadAllFullOptionsSync } from 'owa-options-core';

export default function hideSaveDiscardButtons(currentSubcategory: OptionSubCategory): boolean {
    const options = tryLoadAllFullOptionsSync(currentSubcategory);
    return (
        options &&
        options.reduce(
            (state, option) =>
                state &&
                !!option.fullOptionFormSettings.hideSaveDiscard &&
                option.fullOptionFormSettings.hideSaveDiscard(),
            true
        )
    );
}
